module.exports = __webpack_public_path__ + "img/page_title_03.da81416d.png";